import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReadService } from '@common/service/read.service';
import { AuthService } from '@core/auth/auth.service';
import { environment } from '@environments/environment';
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TmwDatepickerI18n } from './datepicker-i18n';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly  resourceUrl = `${environment.SERVER_BACKOFFICE_API_URL}/api/traductions`;
  currentLang$ = new BehaviorSubject<string>('fr');
  enableEdit$ = new BehaviorSubject<boolean>(false);

  constructor(
    protected http: HttpClient,
    private readonly translateService: TranslateService,
    private readonly readService: ReadService,
    private readonly datepickerI18n: NgbDatepickerI18n,
    private readonly authService: AuthService
  ) {
    this.init();
    this.authService.getProfile().subscribe((profile) => {
      if (profile) {
        this.changeLanguage(profile.lang);
      }
    });
  }

  init() {
    this.translateService.setDefaultLang(this.currentLang$.getValue());
    this.translateService.use(this.currentLang$.getValue());
  }

  toggleEdit() {
    this.enableEdit$.next(!this.enableEdit$.getValue());
  }

  isEdit() {
    return this.enableEdit$.asObservable();
  }

  changeLanguage(languageKey: string) {
    this.currentLang$.next(languageKey);
    this.translateService.use(languageKey);
    (this.datepickerI18n as TmwDatepickerI18n).updateLocal(languageKey);
    this.updateUserLanguage(languageKey);
  }

  getCurrent(): Observable<string> {
    return this.currentLang$;
  }

  save(element: any): Observable<HttpResponse<any>> {
    element.lang = this.currentLang$.getValue();
    return this.http
      .post<any>(this.resourceUrl, element, { observe: 'response' })
      .pipe(
        tap(() => {
          this.translateService.set(element.code, element.libelle);
        })
      );
  }

  find(code: string): Observable<HttpResponse<any>> {
    return this.readService.queryOne('MessageList', {
      params: { lang: this.currentLang$.getValue(), code },
    });
  }

  private updateUserLanguage(language: string) {
    const command = {
      lang: language,
    };
    //this.http.put(`${this.resourceUrl}/lang`, command).subscribe();
  }
}
